<template>
  <div class="intellectual-point-live">
    <div class="app-container">
      <div class="main-wrapper">
        <div class="chatbox">
          <div class="chat-title">Live Chat</div>
          <presentation-chat style="height: 100%"></presentation-chat>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import 'vue-advanced-chat/dist/vue-advanced-chat.css';
import PresentationChat from '@/views/PresentationChat';

export default {
  name: 'PresentationChatPopout',
  components: {
    PresentationChat,
  },
};
</script>

<style>
.app-container {
  background: linear-gradient(180deg, #000, #000);
}
</style>
